<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane class="row" label="Affiliates" name="Affiliates">
        <Affiliates-Card class="col-11"/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Invitations" name="Invitations">
        <Affiliate-Invitations-Card class="col-md-11"/>
      </el-tab-pane>
      <el-tab-pane label="Leads" name="Leads">
        <Leads-Card/>
      </el-tab-pane>
      <el-tab-pane :label="toReceiveLabel" name="To Receive">
        <Leads-Card toReceiveOnly/>
      </el-tab-pane>
      <!-- <el-tab-pane class="row" label="Received" name="EvolutionReceived">
        <Leads-Graph-Multi-View-Card class="col-md-8"
                                     title="Evolution of Leads Received"
                                     subtitle="per affiliate company"
                                     show="Received"
                                    :render="renderReceived"/>
        <Leads-Pie-Chart-Multi-View-Card class="col-md-4 pr-3.1"
                                        title="Leads Received"
                                        subtitle="per affiliate company"
                                        :leadstatus="$store.getters.Lead._status.RECEIVED"
                                        :render="renderReceived"/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Closed" name="EvolutionClosed">
        <Leads-Graph-Multi-View-Card class="col-md-8"
                                     title="Evolution of Leads Closed"
                                     subtitle="per affiliate company"
                                     show="Closed"
                                    :render="renderClosed"/>
        <Leads-Pie-Chart-Multi-View-Card class="col-md-4 pr-3.1"
                                        title="Leads Closed"
                                        subtitle="per affiliate company"
                                        :leadstatus="$store.getters.Lead._status.CLOSED"
                                        :render="renderClosed"/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Close Rate" name="EvolutionCloseRate">
        <Leads-Graph-Multi-View-Card class="col-md-9"
                                     title="Evolution of Close Rate"
                                     subtitle="per affiliate company"
                                     show="Close Rate"
                                    :render="renderCloseRate"/>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import { Lead } from '../../../classes/datamodel'
  export default {
    name: 'multi-company-view',
    props: {},
    mounted () {
      if (!this.$store.getters.companies || this.$store.getters.companies.filter(c => !c.archived).length < 2) {
        this.$router.push({path: '/admin/home/singleview'})
        this.$store.commit('SET_COMPANY_SELECTED', this.$store.getters.companies.filter(c => !c.archived)[0] || 0)
      }
    },
    data () {
      return {
        activeTab: this.$store.getters.leads.length && this.$store.getters.leads.find(l => l.status != 'submitted') > 0 ? 'Leads' : 'Affiliates',
        // Those render attributes below are necessary, to render ChartCards only when tab is
        // selected otherwise there's a bug, the ChartCard doesn't render when the tab isn't selected
        renderReceived: false,
        renderClosed: false,
        renderCloseRate: false,
      }
    },
    methods: {
      handleClick () {
      }
    },
    computed: {
      toReceiveLabel () {
        let str = `To Receive`
        const leads = this.$store.getters.leads.filter(l => l.status == Lead._status.SUBMITTED.value)
        leads.length > 0 ? str += ` (${leads.length})` : null
        return str
      }
    }, 
    watch: {
      activeTab: function (tab) {
        switch (tab) {
          case 'EvolutionReceived':
            this.renderReceived = true
            break
          case 'EvolutionClosed':
            this.renderClosed = true
            break
          case 'EvolutionCloseRate':
            this.renderCloseRate = true
            break
        }
      }
    }
  }
</script>
<style>

</style>
